import { NoopScrollStrategy } from '@angular/cdk/overlay';
import { Component, ElementRef, HostListener, NgZone, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { environment } from '@app-environments/environment';
import { ClassModel } from '@app-models/class';
import { InviteEarnService } from '@app-services/invite-earn/invite-earn.service';
import { UserService } from '@app-services/user/user.service';
import { FeedbackDialogComponent } from '@app-shared/components/live-class-dialog/feedback-dialog/feedback-dialog.component';
import { fromEvent } from 'rxjs';
import { ClassService } from 'src/app/core/services/class.service';
import { EventHandlingService } from 'src/app/core/services/event-handling.service';
import * as Ably from 'ably';
import { HttpClient } from '@angular/common/http';
import { DeviceDetectorService } from 'ngx-device-detector';
import * as moment from 'moment';

@Component({
  selector: 'app-yt-videos',
  templateUrl: './yt-videos.component.html',
  styleUrls: ['./yt-videos.component.css']
})
export class YtVideosComponent implements OnInit {
 
  @ViewChild('scrollContainer', { static: false }) scrollContainer: ElementRef;
  @HostListener('window:CustomEvent', ['$event']) 
  @ViewChild('messageText') chatInputRef!: ElementRef<HTMLInputElement>;

  videoStatus:any = -1;
  urlSafe : SafeResourceUrl;
  classDetails : any;
  ably:any;
  channel:any;
  count = 0;
  showFsMessage:boolean=true
  videoLandscapeSatatus:boolean = true;
  showFullScreenIconAndFeedBackPopup:boolean = false;
  messageHistory:any = [];
  videoFullscreenStatus:boolean = false;
  chatTextareaFocused: boolean = false;
  chatTextareaDisabled: boolean = false;
  LIVE_CLASS_API=environment.LIVE_CLASS_API;
  ABLY_KEY=environment.ablykey

  isEmojiClicked:boolean = false;
  rewatchPayload = {
    endedAt:0,
    duration:0,
    startedAt:0,
    watchedTill:0,
    startTime:0,
    endTime:0,
    platform:''
}

  player: any;
  userDetails: any;
  classId: string;
  constructor(public sanitizer: DomSanitizer, public router:Router, 
    private classService: ClassService,  private dialog: MatDialog, 
    public userService: UserService,    private ngZone: NgZone,  
    private _inviteNdEarn:InviteEarnService,
    private _eventHandlingService:EventHandlingService,
    private http:HttpClient,
    private deviceService: DeviceDetectorService,
    ) {
     }
  showPlayPauseBtns:boolean = false;

  async ngOnInit() {
     // staging ably api keyId
     this.userDetails = JSON.parse(localStorage.getItem('user_details_from_server'))
     this.classId = localStorage.getItem('classId')
    this.ably = new Ably.Realtime.Promise(this.ABLY_KEY);
    await this.ably.connection.once('connected');
    console.log('Connected to Ably!');
    const channelName = localStorage.getItem('channelName');
   // get the channel to subscribe to
    this.channel = this.ably.channels.get(channelName);
    this.channel.attach();
    this.subscribeToChannel()
    if(this.getLocalStorageValueForJoinNow() == 'true'){
      this.getMessageswithPagination();
    }else{this.getMessageForpastClass()}
    this.getClassDetails();
    this.getYTLinkAndSetParameters()
    this.checkAndDisableLiveChat();
    setTimeout(() => {
      this.videoLandscapeSatatus = false;
      this.scrollToLastContent();
    }, 3000);
    (window as any).onYouTubeIframeAPIReady = () => {
      this.player = new (window as any).YT.Player('iframe-id', {
        events: {
          'onStateChange': this.onPlayerStateChange.bind(this)
        }
      });
    };
    this.addEnterKeyListener()
    const isMobile = this.deviceService.isMobile();
    const isTablet = this.deviceService.isTablet();
    const isDesktopDevice = this.deviceService.isDesktop();
    this.rewatchPayload['platform'] = isMobile == true ? 'mweb' : isTablet == true ? 'mweb' : isDesktopDevice == true ? 'web' : 'web';
  }

   /* 
      Subscribe to a channel. 
      The promise resolves when the channel is attached 
      (and resolves synchronously if the channel is already attached).
    */
  async subscribeToChannel(){
    await this.channel.subscribe('myEvent',(message) => { 
      const scrollContainer = this.scrollContainer.nativeElement;
      const isScrollAtBottom = (Math.abs((scrollContainer.scrollHeight - scrollContainer.scrollTop) - scrollContainer.clientHeight) < 50) ? true : false;
      this.messageHistory.push(message.data);
      setTimeout(() => {
        if(isScrollAtBottom)this.scrollToLastContent();
      }, 300);
    });
  }

  async getMessageswithPagination(){
    const limit = 1000;
    const direction = 'forwards'
    let resultPage =  (await this.channel.history({limit,direction}));
    resultPage.items.map((item:any, row:any) => {
        this.messageHistory.push(item.data);
    })
    while (resultPage.hasNext()) {
      await resultPage.next().then(data=>{
        this.messageHistory.push(data.items[0].data)
        resultPage = data;
      });
    }
  }

  appendEmoji(emoji){
    this.isEmojiClicked = true;
    const isFromJoin = localStorage.getItem('isFromJoinClass');
    if(!isFromJoin || isFromJoin == 'false' ){return}
    var textarea = document.getElementById("messageText");
    //@ts-ignore
    textarea.value+= emoji;
  }

  getYTLinkAndSetParameters(){
    const lsYtLink = localStorage.getItem('ytLink');
    const urlParams = new URL(lsYtLink).searchParams;
    const iframe = document.getElementById('iframe-id');
    iframe.setAttribute('donotallowfullscreen', '');
    const ytUrl = urlParams.get('v')
    this.urlSafe= this.sanitizer.bypassSecurityTrustResourceUrl('https://www.youtube.com/embed/'+ytUrl+'?autoplay=1&enablejsapi=1&modestbranding=1');
    const ytSettings = localStorage.getItem('ytSettings');
    if(!(ytSettings && ytSettings == 'true')){
      window['angularComponentReference'] = { component: this, zone: this.ngZone, loadAngularFunction: (event) => this.angularFunctionCalled(event), };  
      var tag = document.createElement('script');
      tag.src = "https://www.youtube.com/iframe_api";
      var firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag,firstScriptTag)
      localStorage.setItem('ytSettings', 'true');
    }else{
      window.location.reload();
    }
  }

  showFullScreen() {
    this.videoFullscreenStatus = true;
    var elem = document.getElementById("video-iframe-container");
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    }
    setTimeout(() => {
      if(this.videoStatus == 2 || this.videoStatus == -1){
        this.playVideo();
      }
    }, 200);    
  }
  exitFullScreen(){
    this.videoFullscreenStatus = false;
    if (document.exitFullscreen) {
      document.exitFullscreen();
    }
  }

  handleSelection(event) {
    console.log(event.char);
  }

  getTime(ms){
    const date = new Date(ms);
    return this.perfectNumber(date.getHours())+':'+this.perfectNumber(date.getMinutes());
  }

  addEnterKeyListener() {
    var textarea = document.getElementById("messageText") as any;
    var isShiftPressed = false;
    textarea.addEventListener('keydown', (event: KeyboardEvent) => {
      if (event.key === 'Shift') {
        isShiftPressed = true;
      }
    });
    textarea.addEventListener('keyup', (event: KeyboardEvent) => {
      if (event.key === 'Shift') {
        isShiftPressed = false;
      }
    })

    textarea.addEventListener('keydown', (event: KeyboardEvent) => {
      if (event.key === 'Enter' && isShiftPressed) {
        event.preventDefault();
        
        // Insert a newline character into the textarea's value
        const cursorPosition = textarea.selectionStart;
        const textBeforeCursor = textarea.value.substring(0, cursorPosition);
        const textAfterCursor = textarea.value.substring(cursorPosition);
        textarea.value = textBeforeCursor + '\n' + textAfterCursor;
        
        // Move the cursor position to after the inserted newline
        textarea.selectionStart = cursorPosition + 1;
        textarea.selectionEnd = cursorPosition + 1;
      }else if (event.key === 'Enter' && !isShiftPressed) {
        setTimeout(() => {
          if(textarea?.value?.replace(/^\n+|\n+$/g, '').length >= 1){
            this.sendMessage(textarea?.value, false);}
          else{
            textarea.value = ''}
        }, 100);
      }
    });
  }

  async sendMessage(event, isTeacher){
    console.log();
    
    if(event?.length === 0) return;
    const userData = this.userService.getMobileAndName();
    const json1 = {
    "sendTime": new Date()?.getTime(),
    "message": event,
    "type": (isTeacher) ? 1 : 2,
    "fromUser": {
      "userUuid": userData.userId,
      "userName": (isTeacher) ? 'Teacher' : userData.firstName + ' ' + userData.lastName,
      "role": (isTeacher) ? "1" : "2"
      }
    };
    // const channelName = localStorage.getItem('channelName');
    await this.channel.publish('myEvent', json1);
    const textarea = document.getElementById("messageText");
    //@ts-ignore
    textarea.value = "";
    this.chatTextareaFocused = false;
    const scrollContainer = this.scrollContainer.nativeElement;
    const isScrollAtBottom = (Math.abs((scrollContainer.scrollHeight - scrollContainer.scrollTop) - scrollContainer.clientHeight) < 50) ? true : false;
    setTimeout(() => {
      if (isScrollAtBottom) this.scrollToLastContent();
    }, 300);
  }

  disableSendButton(message){
    return (message.length == 0) ? true : false
  }

  async dispatchablyenthostory(){
    alert((await this.channel.history()).items.length);
  }

  angularFunctionCalled(data){
    this.videoStatus = data;
    if(this.videoStatus != -1){
      this.showFullScreenIconAndFeedBackPopup = true;
    }
  }

  seekTo(seekValue){
    (<any>window)?.seekVideo(seekValue)?.call &&  (<any>window)?.seekVideo(seekValue);
  }

  playVideo(){
    //@ts-ignore
    window?.playVideo?.call && window?.playVideo();
  }
  pauseVideo(){
    //@ts-ignore
    window?.pauseVideo?.call && window?.pauseVideo();
  }

  loadVideo(event){
    this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl('https://www.youtube.com/embed/'+event+'?enablejsapi=1&modestbranding=1&fs=0&rel=0');
  }

  divClick(event:any){
    if(this.videoStatus == 1){
      this.pauseVideo();
    }else if(this.videoStatus == 2 || this.videoStatus == -1){
      this.playVideo();
    }
  }

  divdblClick(event:any){
    const currentX = event.clientX;
    const offSetWidth = event.currentTarget.clientWidth;
    if(currentX < offSetWidth/2){
      this.seekTo(-10);
    }else if(currentX > offSetWidth/2){
      this.seekTo(10);
    }
    this.divClick('');
  }

  dispatchEventStudentEndClass(){
    let crntUserDetails = this.userService.getMobileAndName();
    let data = {
      userId: crntUserDetails.userId, 
      classId: localStorage.getItem('classId'),
      status: 'left'
    }
    this.classService.studentJoinLeftSession(data).subscribe((res) => console.log(res));
  }

  checkAndDisableLiveChat(){
    const isFromJoin = localStorage.getItem('isFromJoinClass');
    if(!isFromJoin || isFromJoin == 'false' ){
      //@ts-ignore
      document.getElementById('messageText').disabled = true;
      //@ts-ignore
      document.getElementById('chatArrow').disabled = true;
      this.chatTextareaDisabled = true;
     }
  }

  goBack(){
    const isFromJoin = localStorage.getItem('isFromJoinClass');
    this.showFullScreenIconAndFeedBackPopup = true
    if(this.classDetails.meetingStatus=="ended"){
      this.rewatchPayload.endedAt = +moment().unix()
      this.rewatchPayload.endTime = +Math.abs(moment().unix() -this.rewatchPayload.startTime+this.rewatchPayload.startedAt)
      this.rewatchPayload.watchedTill = +Math.abs(moment().unix() -this.rewatchPayload.startTime),
      this.rewatchPayload.duration = +Math.abs(this.rewatchPayload.endedAt -this.rewatchPayload.startedAt)
      this.updateRewatchData()
    }
    if(isFromJoin == 'true' && this.showFullScreenIconAndFeedBackPopup == true){
      this.showFeedbackForm();
      this.dispatchEventStudentEndClass();
      localStorage.setItem('isFromJoinClass','false');
    }
    else
    this.router.navigateByUrl('dashboard/liveclass');
  }

  getClassDetails(){
    const classId = localStorage.getItem('classId');
    let dataToReturn:any
    this.classService.getClassDetails(classId).subscribe(
      (res:any)=>{
        let _res = Object.assign({}, res.data);

        if(Array.isArray(_res.meeting)) {
          _res.meeting = Object.assign({}, _res.meeting[0]);
        }
       this.classDetails = new ClassModel(_res);
      },
    )
  }

  scrollToLastContent() {
    const scrollContainer = this.scrollContainer.nativeElement;
    scrollContainer.scrollTop = scrollContainer.scrollHeight;
  }

 async showFeedbackForm() {
    const crntStuDetails = this.userService.getMobileAndName();
      const config: MatDialogConfig = {
        data: {eclassInfo: this.classDetails, crntStuInfo: crntStuDetails, crntUserInfo: crntStuDetails},
        disableClose: true,
        scrollStrategy: new NoopScrollStrategy()
      };
      const feedbackDialog = this.dialog.open(FeedbackDialogComponent, config);
      feedbackDialog.afterOpened().subscribe(()=>{
        document.body.classList.add('modal-open');
      });
  
      feedbackDialog.afterClosed().subscribe((res: any) => {
        document.body.classList.remove('modal-open');
        localStorage.setItem('feedbackPopupCloased', 'true');
        console.log("Feedback Response: ", res)
       // this.router.navigateByUrl('dashboard/liveclass');
        if(res?._formValues?.questions?.[0]?.options?.[3]?.selected && res?._formValues?.questions?.[1]?.options?.[0]?.selected && environment?.branch == 'staging'){
          this._inviteNdEarn?.userReferralRemider(crntStuDetails.userId,{})?.subscribe((res:any)=>{
            if(res?.showReminder){
              this._inviteNdEarn?.invokeReferralDialog(this.dialog,crntStuDetails?.userId,'youtube',this._eventHandlingService,this.router)
            }else{
            this.router.navigateByUrl('dashboard/liveclass');
            }
          })
        }else{
        this.router.navigateByUrl('dashboard/liveclass');
        }
      })
  }

  perfectNumber(n) {
    return n > 9 ? '' + n : '0' + n;
  }

  getLocalStorageValueForJoinNow(){
    return localStorage.getItem('isFromJoinClass');
  }

  // need to check for creating saperate class service
  getMessageForpastClass(){
    const messageArray:any = [];
    this.http.get(`${this.LIVE_CLASS_API}eclasses/class-messages-history/${ localStorage.getItem('classId')}`).subscribe((res:any)=>{
      res?.data.messages[0].list.map((item:any, row:any) => {
        messageArray.push(item);
      })
    messageArray.reverse();
    this.messageHistory = messageArray;
    })
  }


  focusOutFunction() {
    //console.log('focusOutFunction called');
    this.chatTextareaFocused = false;
  }
  focusFunction(event?:any) {
    //console.log('focusFunction called');
    this.chatTextareaFocused = true;
  }

  onPlayerStateChange(event: any) {
    if (event.data === (window as any).YT.PlayerState.PLAYING && this.classDetails.meetingStatus=='ended') {
      // Video is playing
      console.log('Video started playing', (window as any).YT, event.target.playerInfo);
      this.rewatchPayload.startedAt = event.target.playerInfo.currentTime?.toFixed(0) ? +event.target.playerInfo.currentTime?.toFixed(0): 0
      this.rewatchPayload.startTime = +event.target.playerInfo.currentTimeLastUpdated_?.toFixed(0)
      
    } else if (event.data === (window as any).YT.PlayerState.PAUSED && this.classDetails.meetingStatus=='ended') {
      // Video is paused
      console.log('Video paused',event.target.playerInfo.currentTime?.toFixed(0), (window as any).YT );
      this.rewatchPayload.endedAt = +event.target.playerInfo.currentTime?.toFixed(0)
      this.rewatchPayload.endTime = +event.target.playerInfo.currentTimeLastUpdated_?.toFixed(0)
      this.rewatchPayload.watchedTill = +event.target.playerInfo.currentTime?.toFixed(0)
      this.rewatchPayload.duration = Math.abs(this.rewatchPayload.endedAt -this.rewatchPayload.startedAt)
      this.updateRewatchData()
    }
  }

  videoFullscreenCheck() {
    const isMobile = this.deviceService.isMobile();
    //console.log(isMobile);
    if (window.innerWidth >= 991) {
      if (window.innerHeight == screen.height) {
        // browser is fullscreen
        this.videoFullscreenStatus = true;
      } else {
        this.videoFullscreenStatus = false;
      }
    } else {
      if (window.innerHeight == document.getElementById("video-iframe-container").offsetHeight) {
        // browser is fullscreen
        this.videoFullscreenStatus = true;
      } else {
        this.videoFullscreenStatus = false;
      }
    }
  }

  ngAfterViewInit() {
    setInterval(() => { this.videoFullscreenCheck() }, 500);
  }


  updateRewatchData(){
    this.classService.countRewatchDetails({studentId:this.userDetails?.userId ,classId : this.classId}, this.rewatchPayload).subscribe(data=>{
      console.log(data); 
    })
  }

}
